import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';

/**
 * Functional guard that triggers Auth0 Universal Login redirect.
 * Replaces the sign-in component — all auth UI is handled by Auth0.
 *
 * Reads optional query params added by Auth0 password-ticket emails
 * and the marketing-site registration flow so the login_hint can
 * pre-fill the user's email address.
 */
export const signInGuard: CanActivateFn = (route) => {
	const auth0 = inject(Auth0Service);

	const activated = route.queryParamMap.get('activated');
	const registered = route.queryParamMap.get('registered');
	const email = route.queryParamMap.get('email');

	// Pre-fill email when the user just activated their account or
	// completed social registration on the marketing site.
	const loginHint =
		activated === 'true' || registered === 'true'
			? email || undefined
			: undefined;

	auth0.loginWithRedirect({
		authorizationParams: {
			login_hint: loginHint,
		},
		appState: { target: '/signed-in-redirect' },
	});

	// Cancel navigation — Auth0 will redirect the browser.
	return false;
};
